<template>
  <div class="container-order">
    <div class="order-form-modal" v-if="showModal">
      <div class="blue-panel">
        <div class="panel-head">
          <span>{{ $t("פרטי ההזמנה") }}</span>
          <span class="close-modal" @click="showOrderDetails()"></span>
        </div>
        <div class="panel-body">
          <ul
            class="modal-package-list"
            v-for="content in quoteData.package_contents"
          >
            <li v-for="text in content" v-html="'-' + text"></li>
          </ul>
          <button class="blueBtn" @click="showOrderDetails()">
            {{ $t("סגור") }}
          </button>
        </div>
      </div>
    </div>
    <div class="order-form">
      <div class="blue-panel">
        <div class="panel-head">{{ quoteData.subject }}</div>
        <div class="panel-body">
          <div class="user-order-details">
            <span>{{ $t("תאריכים:") }}</span>
            <span v-html="quoteData.start_date"></span>
            <span v-html="quoteData.end_date"></span>
            <span v-html="quoteData.dayToDay"></span>
          </div>
          <button class="blueBtn" @click="showOrderDetails()">
            {{ $t("לפרטי ההזמנה שלכם לחצו כאן") }}
          </button>
        </div>
      </div>
      <div class="room-details">
        <div class="blue-panel" v-for="(room, idx) in rooms">
          <div class="panel-head">
            <div class="title">{{ $t("חדר") }} {{ idx + 1 }}</div>
            <div class="remove-room" @click="removeRoom(idx)"></div>
          </div>
          <div class="panel-body">
            <div class="guest-item" v-for="(guest, guestIdx) in room">
              <div class="guest-title">
                {{ $t("נוסע") }} {{ guestIdx + 1 }}
                <span
                  class="remove-guest"
                  @click="removeGuest(idx, guestIdx)"
                ></span>
              </div>
              <input
                type="text"
                :placeholder="$t('שם פרטי בעברית')"
                v-model="guest.name"
              />
              <input
                type="text"
                :placeholder="$t('שם משפחה בעברית')"
                v-model="guest.lastname"
              />
              <span
                class="remove-guest"
                @click="removeGuest(idx, guestIdx)"
              ></span>
            </div>
            <button class="add-guest blueBtn" @click="addGuest(idx)">
              + {{ $t("הוספת נוסע") }}
            </button>
          </div>
        </div>
      </div>
      <div class="complete-order">
        <button class="addRoom" @click="addRoom()">
          + {{ $t("הוספת חדר") }}
        </button>
        <button
          class="sendRoom"
          ref="submitBtn"
          @click="sendRoom()"
          v-if="!success"
        >
          {{ $t("שלח הזמנה") }}
        </button>
        <span class="success" v-if="success">{{ $t("הזמנתך נשלחה") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../../API";
import { $t } from "../../i18n";

export default {
  data() {
    return {
      quoteData: window.quoteData,
      rooms: [
        [
          { name: "", lastname: "" },
          { name: "", lastname: "" },
        ],
      ],
      showModal: false,
      success: false,
    };
  },
  methods: {
    sendRoom() {
      if (!this.rooms.length) {
        alert($t("חובה להוסיף חדר אחד לפחות"));
        return;
      }

      if (api.SENDING_ORDER) {
        return;
      }

      $(this.$refs.submitBtn).btnLoader().show();

      api.sendOrderDetails(this.rooms, this.quoteData.quoteId).then((res) => {
        $(this.$refs.submitBtn).btnLoader().hide();
        api.SENDING_ORDER = false;

        if (!res.error) {
          this.success = true;
        }
      });
    },
    showOrderDetails() {
      this.showModal = !this.showModal;
    },
    removeRoom(idx) {
      this.rooms.splice(idx, 1);
    },
    addRoom() {
      this.rooms.push([{ name: "", lastname: "" }]);
    },
    addGuest(roomIdx) {
      this.rooms[roomIdx].push({
        name: "",
        lastname: "",
      });
    },
    removeGuest(roomIdx, idx) {
      this.rooms[roomIdx].splice(idx, 1);

      if (!this.rooms[roomIdx].length) {
        this.rooms.splice(roomIdx, 1);
      }
    },
  },
  mounted() {},
  computed: {},
};
</script>

<style lang="scss">
.order-form-modal {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5545454;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;

  .blue-panel {
    max-width: 600px;
    width: 100%;
  }
}

.order-form {
  padding-top: 30px;
}

.complete-order {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .success {
    font-weight: bold;
    font-size: 19px;
  }
}

.blueBtn {
  background: #33bbf5;
  color: #fff;
  padding: 0 19px 3px;
  height: 40px;
  line-height: 37px;
  border-radius: 5px;
  margin: 24px 0 0;
  font-size: 19px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  will-change: background;
}

.addRoom {
  height: 40px;
  line-height: 37px;
  padding: 0 20px 3px;
  border: 1px solid #000;
  border-radius: 5px;
  color: #000;
  font-size: 19px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  will-change: border-color, color;
  background-color: transparent;
}

.sendRoom {
  background: #464f5d;
  float: left;
  height: 40px;
  line-height: 37px;
  min-width: 130px;
  padding: 0 20px 3px;
  font-size: 19px;
  color: #fff;
  border-radius: 5px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  will-change: background;
  border: none;
}

.blue-panel {
  margin-bottom: 40px;
  position: relative;

  .panel-head {
    background: #1eb5f5;
    min-height: 52px;
    line-height: 52px;
    color: #fff;
    font-size: 22px;
    font-weight: 700;
    display: flex;
    justify-items: center;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;

    @media (max-width: 767px) {
      font-size: 17px;
    }

    .close-modal {
      display: block;
      background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='348.333px' height='348.334px' viewBox='0 0 348.333 348.334' style='enable-background:new 0 0 348.333 348.334;' xml:space='preserve'%3E%3Cg%3E%3Cpath fill='%23ffffff' d='M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85 c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563 c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85 l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554 L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z'/%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
      background-size: contain;
      min-width: 17px;
      height: 17px;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: center;
    }

    .remove-room {
      display: block;
      background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='348.333px' height='348.334px' viewBox='0 0 348.333 348.334' style='enable-background:new 0 0 348.333 348.334;' xml:space='preserve'%3E%3Cg%3E%3Cpath fill='%23ffffff' d='M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85 c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563 c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85 l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554 L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z'/%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
      background-size: contain;
      min-width: 17px;
      height: 17px;
      cursor: pointer;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .panel-body {
    background: #fff;
    padding: 25px 29px 29px;

    @media (max-width: 767px) {
      padding: 13px;
    }

    .modal-package-list {
      li {
        margin-bottom: 10px;
        display: flex;
        font-size: 18px;
        flex-wrap: wrap;
      }

      p {
        margin: 0;
      }
    }

    .user-order-details {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      color: #36445c;
      display: flex;

      @media (max-width: 767px) {
        flex-direction: column;
      }

      span {
        margin-left: 6px;
      }
    }

    .guest-item {
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      @media (max-width: 767px) {
        flex-direction: column;
        align-items: unset;
      }

      .guest-title {
        min-width: 58px;
        line-height: 40px;
        padding: 0 0 0 5px;
        font-weight: bold;

        .remove-guest {
          display: none;
        }

        @media (max-width: 767px) {
          display: flex;
          align-items: center;

          .remove-guest {
            display: block;
          }
        }
      }

      span.remove-guest {
        margin-right: auto;
        display: block;
        background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='348.333px' height='348.334px' viewBox='0 0 348.333 348.334' style='enable-background:new 0 0 348.333 348.334;' xml:space='preserve'%3E%3Cg%3E%3Cpath d='M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85 c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563 c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85 l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554 L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z'/%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3Cg%3E%3C/g%3E%3C/svg%3E%0A");
        background-size: contain;
        min-width: 17px;
        height: 17px;
        cursor: pointer;
        background-repeat: no-repeat;
        background-position: center;

        @media (max-width: 767px) {
          display: none;
        }
      }

      input {
        background: rgba(241, 241, 241, 0.6);
        width: 100%;
        height: 45px;
        font-weight: bold;
        border: none;
        border-radius: 5px;
        color: #36445c;
        font-size: 19px;
        padding: 0 15px 3px;
        margin-left: 10px;

        @media (max-width: 767px) {
          margin-left: 0;
          margin-bottom: 10px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
